import React from 'react';
import { cn } from '@/utils/cn';
import { TablePagination } from '@/components/ui/TablePagination';
import { CardList } from '@/components/ui/CardList';

export function ProjectHistoryList({ history }: { history: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100  overflow-hidden">
      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50/50 text-xs font-normal text-slate-400 border-b border-slate-100">
              <th className="py-3 px-4 font-normal">Đối tượng</th>
              <th className="py-3 px-4 font-normal">Người thực hiện</th>
              <th className="py-3 px-4 font-normal">Phân hệ</th>
              <th className="py-3 px-4 font-normal">Hành động</th>
              <th className="py-3 px-4 font-normal">Nội dung thay đổi</th>
              <th className="py-3 px-4 font-normal">Giá trị cũ</th>
              <th className="py-3 px-4 font-normal">Giá trị mới</th>
              <th className="py-3 px-4 text-center font-normal">Chi tiết</th>
            </tr>
          </thead>
          <tbody className="text-xs divide-y divide-slate-50">
            {history.map((item) => (
              <tr key={item.id} className="hover:bg-slate-50/50 transition-colors group">
                <td className="py-4 px-4">
                   <div className="flex items-center gap-2">
                      <i className="ri-time-line text-slate-400" />
                      <span className="font-normal text-slate-500 whitespace-nowrap">{item.time}</span>
                   </div>
                </td>
                <td className="py-4 px-4">
                  <div className="flex items-center gap-3">
                    <img src={item.user.avatar} alt="" className="w-8 h-8 rounded-full border border-slate-100 shrink-0" />
                    <div className="flex flex-col min-w-0">
                      <span className="font-normal text-slate-700 truncate">{item.user.name}</span>
                      <span className="text-xs text-slate-400 font-normal">{item.user.role}</span>
                    </div>
                  </div>
                </td>
                <td className="py-4 px-4">
                   <div className={cn("inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md sm:text-sm text-xs font-normal", item.moduleColor)}>
                      <i className={cn(item.moduleIcon, "sm:text-sm text-xs")} />
                      <span>{item.module}</span>
                   </div>
                </td>
                <td className="py-4 px-4">
                   <span className="sm:text-sm text-xs font-normal text-slate-500"> {item.action}</span>
                </td>
                <td className="py-4 px-4">
                   <p className="font-normal text-slate-700 leading-relaxed max-w-[240px] truncate">{item.content}</p>
                </td>
                <td className="py-4 px-4 text-slate-400 font-normal">{item.oldValue}</td>
                <td className="py-4 px-4 text-emerald-600 font-normal">{item.newValue}</td>
                <td className="py-4 px-4 text-center">
                   <button className="sm:text-sm text-xs font-normal text-emerald-600 hover:underline">Xem chi tiết</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card List */}
      <div className="lg:hidden p-4">
        <CardList 
          items={history}
          renderCard={(item) => (
            <div key={item.id} className="bg-white p-3 rounded-md border border-slate-100 space-y-4">
              <div className="flex justify-between items-start">
                 <div className="flex items-center gap-2">
                    <img src={item.user.avatar} alt="" className="w-8 h-8 rounded-full" />
                    <div>
                       <p className="sm:text-sm text-xs font-normal text-slate-900">{item.user.name}</p>
                       <p className="sm:text-sm text-xs font-normal text-slate-400">{item.time}</p>
                    </div>
                 </div>
                 <div className={cn("px-2 py-0.5 rounded-md sm:text-sm text-xs font-normal", item.moduleColor)}>{item.module}</div>
              </div>
              <p className="text-xs font-normal text-slate-700">{item.content}</p>
              <div className="grid grid-cols-2 gap-4 border-t border-slate-50 pt-3">
                 <div className="space-y-1">
                    <p className="sm:text-sm text-xs text-slate-400 font-normal">Trước</p>
                    <p className="sm:text-sm text-xs font-normal text-slate-400">{item.oldValue}</p>
                 </div>
                 <div className="space-y-1 text-right">
                    <p className="sm:text-sm text-xs text-slate-400 font-normal">Sau</p>
                    <p className="sm:text-sm text-xs font-normal text-emerald-600">{item.newValue}</p>
                 </div>
              </div>
            </div>
          )}
        />
      </div>

      <div className="px-4 border-t border-slate-50 bg-slate-50/30">
        <TablePagination currentPage={1} totalItems={245} pageSize={10} onPageChange={() => {}} itemLabel="lịch sử" />
      </div>
    </div>
  );
}
